import { fromJS, OrderedSet } from 'immutable';

import { SEARCH, SEARCH_SUCCESS, SEARCH_FAILED, CLEAR } from './constants';

export const initialState = fromJS({
  results: OrderedSet(),
  term: '',
  searchLoading: false,
  error: false,
});

function inviteAttendeesOverlayReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH:
      if (action.term.length > 1) {
        return state.merge({ searchLoading: true, term: action.term });
      }
      return state.merge({
        searchLoading: false,
        term: action.term,
        results: OrderedSet(),
      });

    case SEARCH_SUCCESS:
      return state.merge({
        searchLoading: false,
        results: OrderedSet(action.results),
      });

    case SEARCH_FAILED:
      return state.merge({ searchLoading: false, error: action.error });

    case CLEAR:
      return initialState;

    default:
      return state;
  }
}

export default inviteAttendeesOverlayReducer;
